import Joi from "joi";

import { ImportsFields } from "~/constants/forms";
import { TEMPLATE_NAME } from "~/constants/strings";

export default Joi.object({
  [ImportsFields.TEMPLATE_FILE]: Joi.any().label(TEMPLATE_NAME).required(),
});
